import React, { useContext, useState } from 'react';
import { RicosContext } from 'ricos-context';
import { toHexFormat } from 'ricos-styles';
import { dataHook, WEB_ADDRESS_CATEGORY, ADD_PLUGIN_LINK_BI, LINK_BUTTON_TYPE } from 'wix-rich-content-common';
import { KEYS_CHARCODE } from 'wix-rich-content-editor-common';
import { SettingsMobileHeader, SettingsPanelHeader, FocusManager, Tabs, Tab, SettingsPanelFooter, BUTTON_SIZE } from 'wix-rich-content-ui-components';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { DesignComponent } from '../components/design-component.js';
import { SettingsComponent } from '../components/settings-component.js';
import { SETTINGS_TAB } from '../constants.js';
import { ROOT, BUTTON_INPUT_MODAL } from '../dataHooks.js';
import '../toggled-color-picker-f5ca9740.js';
import 'wix-rich-content-plugin-commons';
import '../components/color-toggle-component.js';
import 'classnames';
import '../defaults.js';
import '../utils/isDefined.js';
import 'ricos-schema';
import 'wix-rich-content-toolbars-modals';
import '../types.js';

var css_248z = "[dir=ltr] .wvpg6{text-align:left}[dir=rtl] .wvpg6{text-align:right}@supports not (contain:inline-size){@media only screen and (max-width:640px){.wvpg6{height:calc(100% - 100px)}[dir] .wvpg6{padding:0}}}@container (width < 640px){.wvpg6{height:calc(100% - 100px)}[dir] .wvpg6{padding:0}}[dir] .GrVyj{margin-top:100px}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] .XzuwW{padding-bottom:0;padding-top:24px}}}@container (width < 640px){[dir] .XzuwW{padding-bottom:0;padding-top:24px}}[dir] ._7DkGr{border-top:none}[dir] .GGJ-h{border-top:1px solid #ccc}._4wLQD{height:calc(100vh - 152px);overflow-y:scroll}@supports not (contain:inline-size){@media only screen and (max-width:640px){._4wLQD{height:calc(100vh - 155px);overflow-x:hidden}}}@container (width < 640px){._4wLQD{height:calc(100vh - 155px);overflow-x:hidden}}.QUz-5{align-items:center;box-sizing:border-box;display:flex;height:auto}[dir] .QUz-5{margin-top:1px;padding:18px 30px 21px}._7HbCn{color:var(--ricos-settings-text-color,#333);font-size:20px;width:100%}[dir] ._7HbCn{margin-bottom:10px;margin-top:13px}@supports not (contain:inline-size){@media only screen and (max-width:640px){._7HbCn{color:var(--ricos-settings-text-color,#000);font-size:20px;line-height:1.4}[dir] ._7HbCn{margin-top:0}}}@container (width < 640px){._7HbCn{color:var(--ricos-settings-text-color,#000);font-size:20px;line-height:1.4}[dir] ._7HbCn{margin-top:0}}._5F-Jh{font-size:16px;width:100%}[dir] ._5F-Jh{margin:10px 0}@supports not (contain:inline-size){@media only screen and (max-width:640px){._5F-Jh{font-size:16px}[dir] ._5F-Jh{margin:9px 0 0;padding-bottom:8px}[dir=ltr] ._5F-Jh{padding-left:20px}[dir=rtl] ._5F-Jh{padding-right:20px}}}@container (width < 640px){._5F-Jh{font-size:16px}[dir] ._5F-Jh{margin:9px 0 0;padding-bottom:8px}[dir=ltr] ._5F-Jh{padding-left:20px}[dir=rtl] ._5F-Jh{padding-right:20px}}[dir=ltr] .sKZAy{margin-right:12px}[dir=rtl] .sKZAy{margin-left:12px}.CqNEa{color:red}._1-gFt{color:#f97972;position:absolute;top:2px}[dir=ltr] ._1-gFt{left:150px}[dir=rtl] ._1-gFt{right:150px}[dir=ltr] .E1IJy+.E1IJy{border-left:0}[dir=rtl] .E1IJy+.E1IJy{border-right:0}.Wwkn1{height:634px;overflow-y:scroll}._0iL2f{display:block}[dir] ._0iL2f{margin-top:15px}.rYrVM:hover{opacity:.8}.L8O-G{box-sizing:border-box;height:calc(100% - 227px);overflow:scroll;position:absolute;top:127px;width:100%}[dir] .L8O-G{padding:24px}.L8O-G *,.L8O-G :after,.L8O-G :before{box-sizing:inherit}.L8O-G input{box-sizing:border-box}@supports not (contain:inline-size){@media only screen and (max-width:640px){.L8O-G{height:calc(100% - 100px);top:100px}[dir] .L8O-G{padding:20px}}}@container (width < 640px){.L8O-G{height:calc(100% - 100px);top:100px}[dir] .L8O-G{padding:20px}}.bjzRo{max-width:420px;position:absolute;top:77px;width:100%;z-index:2}[dir] .bjzRo{background-color:#fff}@supports not (contain:inline-size){@media only screen and (max-width:640px){.bjzRo{max-width:100%;top:50px}}}@container (width < 640px){.bjzRo{max-width:100%;top:50px}}";
var styles = {"button_inputModal_container":"wvpg6","button_inputModal_container_mobile":"GrVyj","button_inputModal_design_component_container":"XzuwW","button_inputModal_focus_manager":"_7DkGr","button_inputModal_separator":"GGJ-h","button_inputModal_scroll":"_4wLQD","button_inputModal_header":"QUz-5","button_inputModal_header_text":"_7HbCn","button_inputModal_design_header_text":"_5F-Jh","header_icon":"sKZAy","errorMessage":"CqNEa","button_inputModal_errorIcon":"_1-gFt","tabs_headers_option":"E1IJy","scroll_container":"Wwkn1","button_inputModal_tabLabel":"_0iL2f","scrollbar_thumb":"rYrVM","button_tab_section":"L8O-G","button_tabs_headers":"bjzRo"};
styleInject(css_248z);

const SettingsModalContent = ({
  buttonData,
  t,
  onChange,
  onSave,
  onCancel,
  isMobile,
  settings,
  helpers,
  nodeId
}) => {
  var _a, _b, _c, _d, _e, _f;
  const { jsdomMode } = useContext(RicosContext);
  const [activeTab, setActiveTab] = useState(SETTINGS_TAB.SETTINGS);
  const [computedStyles] = useState(() => getComputedButtonStyles());
  const initialData = {
    border: {
      width: 0,
      radius: 0
    },
    colors: {
      text: (_b = (_a = settings.colors) == null ? void 0 : _a.color1) != null ? _b : computedStyles.color,
      border: (_d = (_c = settings.colors) == null ? void 0 : _c.color8) != null ? _d : computedStyles.borderColor,
      background: (_f = (_e = settings.colors) == null ? void 0 : _e.color8) != null ? _f : computedStyles.background
    }
  };
  const handleOnSave = () => {
    triggerLinkBi();
    onSave();
  };
  const triggerLinkBi = () => {
    var _a2, _b2, _c2, _d2, _e2;
    const settings2 = buttonData;
    const params = {
      link: (_a2 = settings2.link) == null ? void 0 : _a2.url,
      newTab: ((_b2 = settings2.link) == null ? void 0 : _b2.target) === "BLANK",
      category: WEB_ADDRESS_CATEGORY,
      rel: ((_d2 = (_c2 = settings2.link) == null ? void 0 : _c2.rel) == null ? void 0 : _d2.nofollow) && "nofollow"
    };
    (_e2 = helpers == null ? void 0 : helpers.onPluginAction) == null ? void 0 : _e2.call(helpers, ADD_PLUGIN_LINK_BI, {
      plugin_id: LINK_BUTTON_TYPE,
      params
    });
  };
  const handleKeyPress = (e) => {
    if (e.charCode === KEYS_CHARCODE.ENTER) {
      onSave();
    }
    if (e.charCode === KEYS_CHARCODE.ESCAPE) {
      onCancel();
    }
  };
  const resolveButtonStyles = (componentData) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g, _h, _i, _j;
    return {
      border: {
        width: (_b2 = (_a2 = componentData == null ? void 0 : componentData.border) == null ? void 0 : _a2.width) != null ? _b2 : initialData.border.width,
        radius: (_d2 = (_c2 = componentData == null ? void 0 : componentData.border) == null ? void 0 : _c2.radius) != null ? _d2 : initialData.border.radius
      },
      colors: {
        text: (_f2 = (_e2 = componentData == null ? void 0 : componentData.colors) == null ? void 0 : _e2.text) != null ? _f2 : initialData.colors.text,
        border: (_h = (_g = componentData == null ? void 0 : componentData.colors) == null ? void 0 : _g.border) != null ? _h : initialData.colors.border,
        background: (_j = (_i = componentData == null ? void 0 : componentData.colors) == null ? void 0 : _i.background) != null ? _j : initialData.colors.background
      }
    };
  };
  const resolveStylesChange = ({ colors, border }, { colors: initialColors, border: initialBorders }) => {
    return {
      colors: {
        text: colors.text === initialColors.text ? void 0 : colors.text,
        background: colors.background === initialColors.background ? void 0 : colors.background,
        border: colors.border === initialColors.border ? void 0 : colors.border
      },
      border: {
        width: border.width === initialBorders.width ? void 0 : border.width,
        radius: border.radius === initialBorders.radius ? void 0 : border.radius
      }
    };
  };
  function getComputedButtonStyles() {
    const el = document.querySelector(dataHook(`editor-${nodeId}`, ROOT));
    if (!el) {
      throw new Error(`Button element with the given identifier does not exist within the DOM.`);
    }
    const styles2 = window.getComputedStyle(el);
    const color = toHexFormat(styles2.getPropertyValue("color"));
    const background = toHexFormat(styles2.getPropertyValue("background-color"));
    const borderColor = toHexFormat(styles2.getPropertyValue("border-color"));
    return { color, background, borderColor };
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: styles.button_inputModal_container, "data-hook": BUTTON_INPUT_MODAL }, isMobile ? /* @__PURE__ */ React.createElement(
    SettingsMobileHeader,
    {
      onSave: handleOnSave,
      onCancel,
      title: t("ButtonModal_Header"),
      t
    }
  ) : /* @__PURE__ */ React.createElement(SettingsPanelHeader, { title: t("ButtonModal_Header"), onClose: onCancel }), /* @__PURE__ */ React.createElement(FocusManager, { jsdomMode }, /* @__PURE__ */ React.createElement("div", { className: styles.button_inputModal_focus_manager }, /* @__PURE__ */ React.createElement(
    Tabs,
    {
      value: activeTab,
      headersStyle: styles.button_tabs_headers,
      onTabSelected: (value) => setActiveTab(value)
    },
    /* @__PURE__ */ React.createElement(
      Tab,
      {
        label: t("ButtonModal_Settings_Tab"),
        value: SETTINGS_TAB.SETTINGS,
        className: styles.button_inputModal_tabLabel
      },
      /* @__PURE__ */ React.createElement("div", { className: styles.button_tab_section, role: "button", tabIndex: 0 }, /* @__PURE__ */ React.createElement(
        SettingsComponent,
        {
          buttonData,
          onChange,
          onKeyPress: handleKeyPress
        }
      ))
    ),
    /* @__PURE__ */ React.createElement(
      Tab,
      {
        label: t("ButtonModal_Design_Tab"),
        value: SETTINGS_TAB.DESIGN,
        className: styles.button_inputModal_tabLabel
      },
      /* @__PURE__ */ React.createElement("div", { className: styles.button_tab_section }, /* @__PURE__ */ React.createElement(
        DesignComponent,
        {
          stylesData: resolveButtonStyles(buttonData.styles),
          onChange: (newData) => {
            const stylesObj = resolveStylesChange(newData, initialData);
            onChange({ styles: stylesObj });
          },
          settings
        }
      ))
    )
  )))), !isMobile && /* @__PURE__ */ React.createElement(
    SettingsPanelFooter,
    {
      fixed: true,
      save: handleOnSave,
      cancel: onCancel,
      t,
      buttonSize: BUTTON_SIZE.small
    }
  ));
};

export { SettingsModalContent };
//# sourceMappingURL=SettingsModalContent.js.map
